export const getCookie = (name) => {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

export const getCookieDomain = (hostname = window.location.hostname) => {
    if (!hostname || hostname === "localhost" || /^\d{1,3}(\.\d{1,3}){3}$/.test(hostname)) {
        return "";
    }

    if (hostname.endsWith(".bergsoemetals.com")) {
        return ".bergsoemetals.com";
    }

    if (hostname.endsWith(".panyaraksa.com")) {
        return ".panyaraksa.com";
    }

    return "";
}

export const setCookie = (name,value,days,domain = "") => {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    var domainPart = domain ? "; domain=" + domain : "";
    document.cookie = name + "=" + (value || "")  + expires + domainPart + "; path=/";
}

export const eraseCookie = (name, domain = "") => {   
    var domainPart = domain ? "; Domain=" + domain : "";
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;' + domainPart + ';';
}
